import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {PublicLayoutModule} from './shared/layout/public-layout/public-layout.module';
import {PublicModule} from './feature-module/public/public.module';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MessageService} from 'primeng/api';
import {httpInterceptorProviders} from './shared/interceptor';
import {reducers} from './store/app.reducer';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {AuthEffects} from './store/authentication/auth.effect';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {HashLocationStrategy, LocationStrategy} from '@angular/common';
import {NgxMaskModule} from 'ngx-mask';
import {NgProgressModule} from '@ngx-progressbar/core';
// import {NgProgressHttpModule} from '@ngx-progressbar/http';
import {AgmCoreModule} from '@agm/core';

// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    PublicLayoutModule,
    PublicModule,
    StoreModule,
    StoreModule.forRoot(reducers),
    EffectsModule.forRoot([AuthEffects]),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
    }),
    NgxMaskModule.forRoot(),
    NgProgressModule,
    // NgProgressHttpModule,
    AgmCoreModule.forRoot({
      // please get your own API key here:
      // https://developers.google.com/maps/documentation/javascript/get-api-key?hl=en
      apiKey: 'AIzaSyDloJCMYtTjy_H4hGHYnbMx9GiYWSM8UJ4'
    })
  ],
  providers: [MessageService, httpInterceptorProviders, {provide: LocationStrategy, useClass: HashLocationStrategy}],
  bootstrap: [AppComponent],
  exports: []
})
export class AppModule { }
